// Shared rules for the /book flow: "What do you need shot?" then only questions for that choice.
import { EMPTY_HOME_FORM } from '@/lib/realEstateOrder';
import { EMPTY_LAND_FORM } from '@/lib/vacantLand';

export const BOOK_DRAFT_KEY = 'rc_book_draft';

export const KINDS = [
  { value: 'real_estate', label: 'Real Estate', description: 'Homes, commercial properties and vacant land' },
  { value: 'video', label: 'Video', description: 'Property tours, brand films and social reels · quote' },
  { value: 'other', label: 'Other service', description: 'Portraits, events, virtual staging, design and more · quote' },
];

export const PROPERTY_TYPES = [
  { value: 'home', label: 'Residential', description: 'House, condo or townhome · packages from $199' },
  { value: 'commercial', label: 'Commercial', description: 'Office, retail, industrial and more · quote' },
  { value: 'land', label: 'Vacant land', description: 'Drone photos of a parcel · paid in full at booking' },
];

export const RE_KINDS = PROPERTY_TYPES.map((p) => p.value);
export const ALL_KINDS = [...KINDS.map((k) => k.value), ...RE_KINDS];
export const QUOTE_LABELS = { video: 'Video', other: 'Other service', commercial: 'Commercial real estate' };

export const QUOTE_SERVICES = {
  video: ['Property video tour', 'Aerial video', 'Brand video', 'Vertical social videos', 'Short-form content', 'Marketing reels', 'Something else'],
  other: [
    'Headshots & portraits', 'Private sessions', 'Couples & engagements', 'Pet photography', 'Events & lifestyle',
    'Commercial / business aerials', 'Floor plans', 'Virtual twilight', 'Virtual staging & renovation', 'Property website',
    'Custom artwork & prints', 'AI upscaling & restoration', 'Creative retouching', 'Website design', 'IT & digital services', 'Something else',
  ],
};

export const TIMELINES = ['ASAP (within 1 week)', 'Within 2 weeks', 'Within 1 month', 'Flexible / no rush', 'A specific date (add it in the description)'];
export const BUDGETS = ['Under $500', '$500 – $1,000', '$1,000 – $2,500', '$2,500 – $5,000', '$5,000+', 'Not sure yet'];

const EMPTY_QUOTE = { service: '', location: '', timeline: '', description: '', budget: '' };
const EMPTY_DRAFT = {
  kind: '', reKind: '', home: EMPTY_HOME_FORM, land: EMPTY_LAND_FORM, video: EMPTY_QUOTE, other: EMPTY_QUOTE,
  commercial: { address: '', description: '' },
  contact: { contactName: '', contactPhone: '' },
};

export const loadBookDraft = () => {
  try {
    const d = JSON.parse(localStorage.getItem(BOOK_DRAFT_KEY)) || {};
    return Object.fromEntries(Object.entries(EMPTY_DRAFT).map(([k, v]) => [k, typeof v === 'object' ? { ...v, ...(d[k] || {}) } : d[k] || v]));
  } catch {
    return EMPTY_DRAFT;
  }
};

export const saveBookDraft = (draft) => localStorage.setItem(BOOK_DRAFT_KEY, JSON.stringify(draft));

export const clearBookDraft = (kind) => {
  const d = loadBookDraft();
  saveBookDraft({ ...d, kind: '', [kind]: EMPTY_DRAFT[kind] });
};

export const today = () => new Date().toLocaleDateString('en-CA');
export const fmtDate = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : '—');

export const apiError = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (res.ok) return { data };
  const msg = typeof data.detail === 'string' ? data.detail
    : Array.isArray(data.detail) ? (data.detail[0]?.msg || '').replace(/^Value error, /, '') : '';
  return { error: msg || 'Please check your answers and try again.' };
};
